<template>
  <v-bottom-navigation
    :value="activeBtn"
    grow
    color="teal"
    shift
    class="mb-1"
  >
    <v-btn
      value="aluno"
      to="/aluno/profile"
      style="height: 100%"
    >
      <span>Perfil do Aluno</span>
      <v-icon>person</v-icon>
    </v-btn>
    <v-btn
      value="alunoShedule"
      to="/aluno/schedule"
      style="height: 100%"
    >
      <span>Aulas Práticas</span>
      <v-icon>mdi-format-list-numbered</v-icon>
    </v-btn>
    <v-btn
      value="Teorico"
      to="/aluno/teorico"
      style="height: 100%"
    >
      <span>Aulas Teóricas</span>
      <v-icon>mdi-book-open-page-variant</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>


<script>
  export default {
    data () {
      return {
        activeBtn: 0,
      }
    },
  }
</script>
